// The phone Shipping screen's `ui`: phoneUi's full-screen questions, labels at the station GET /features names
// (features/print/labelStation: the Shipping Zebra once the shipping Pi prints, else the Laser Zebra), and every
// "who is doing this" PIN answered by the Working-as session (features/operatorSession/workingAsUi), as the
// desktop hub does. A manager's approval (face: false) is still typed every time.
import { useMemo } from "react";
import { phoneUi } from "../../ui/phoneUi";
import { workingAsUi } from "../../../features/operatorSession/workingAsUi";
import { useLabelStation } from "../../../features/print/labelStation";

export default function useShippingUi() {
  const station = useLabelStation();
  return useMemo(() => workingAsUi({ ...phoneUi, labelStation: station, printTrigger: "phone_shipping" }), [station]);
}
